<app-auth-wrapper [title]="'Access Denied'">
    <p>You have insufficient permissions to access the CRM application.</p>
    <div class="buttonContainer">
        <button (click)="onGoBack($event)" class="primary-btn">Go back to Login</button>
    </div>
</app-auth-wrapper>
